<template>
  <g
    v-if="width > 0"
    class="z-10 origin-center"
    :style="{
      transform: 'rotate(' + skillStartAngle + ') ',
    }"
    @mouseenter="emits('over', skill.id)"
    @mouseleave="emits('out')"
  >
    <path class="cursor-pointer fill-transparent" :d="dBackground" />
    <MenonCharIndividualDots
      v-if="perspectiveKey"
      :max-value="maxValue"
      :color="skill.color"
      :width="width"
      :index="index"
      :total-number-of-segments="numberOfSegments"
      :hovered="hovered"
      :split-by-perspective="splitByPerspective"
      :topic-perspectives="topicPerspectives ?? []"
      :perspective-averages="perspectiveAverages.filter((p) => p.key === perspectiveKey)"
    />
    <MenonCharIndividualDots
      v-else-if="perspectives.size > 1"
      :max-value="maxValue"
      :color="skill.color"
      :width="width"
      :index="index"
      :total-number-of-segments="numberOfSegments"
      :hovered="hovered"
      :split-by-perspective="splitByPerspective"
      :topic-perspectives="topicPerspectives ?? []"
      :perspective-averages="perspectiveAverages"
    />
  </g>
</template>
<script lang="ts" setup>
  import type { Skill } from '@/core/models/skill'
  import { computed } from 'vue'
  import MenonCharIndividualDots from './MenonCharIndividualDots.vue'
  import type { Perspective } from '@/core/models/perspective.ts'

  interface Props {
    skill: Skill
    numberOfSegments: number
    index: number
    width: number
    maxValue: number
    topicPerspectives: ReadonlyArray<Perspective>
    perspectiveAverages: ReadonlyArray<{ key: string; average: number | null }>
    hovered: boolean
    perspectives: ReadonlySet<string>
    /** When set, this wedge is one perspective and shows its marker instead of hover dots. */
    perspectiveKey?: string
    splitByPerspective: boolean
  }

  const props = defineProps<Props>()

  const emits = defineEmits<{
    (e: 'out'): void
    (e: 'over', skillId: string): void
  }>()

  const skillStartAngle = computed(() => {
    return props.index * skillAngle.value + 'rad'
  })

  const skillAngle = computed(() => {
    return (2 * Math.PI) / props.numberOfSegments
  })

  const radius = computed(() => {
    return props.width / 2
  })

  const dBackground = computed(() => {
    const angle = skillAngle.value / 2
    const x = Math.sin(angle) * radius.value
    const y = Math.cos(angle) * radius.value

    return `M ${radius.value} ${radius.value} l -${x} -${y} a ${radius.value} ${radius.value} 0 0 1 ${2 * x} 0 L ${radius.value} ${radius.value}`
  })
</script>
